import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconMonitorSpeaker",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (r) => Object.keys(l).includes(r)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, u = ["aria-label", "data-qa", "aria-hidden"];
function p(r, t, i, f, m, e) {
  return d(), n("svg", {
    "aria-label": i.ariaLabel,
    class: o([e.iconSizeClass, "d-icon d-icon--monitor-speaker"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Monitor Speaker",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    a("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.25 10a.5.5 0 0 1 .5-.5H4a.5.5 0 0 1 0 1H2.75a.5.5 0 0 1-.5-.5ZM8 4.5a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H8.5a.5.5 0 0 1-.5-.5Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7 2.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H7ZM5.5 3A1.5 1.5 0 0 1 7 1.5h3A1.5 1.5 0 0 1 11.5 3v6a1.5 1.5 0 0 1-1.5 1.5H7A1.5 1.5 0 0 1 5.5 9V3ZM.94 2.94A1.5 1.5 0 0 1 2 2.5h2a.5.5 0 0 1 0 1H2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 0 1H2A1.5 1.5 0 0 1 .5 7V4c0-.398.158-.78.44-1.06Z",
      "clip-rule": "evenodd"
    }, null, -1),
    a("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.5 7.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, u);
}
const H = /* @__PURE__ */ s(c, [["render", p]]);
export {
  H as default
};
//# sourceMappingURL=monitor-speaker.js.map
